import { render, staticRenderFns } from "./ExternalMonitoring.vue?vue&type=template&id=18df68fa&scoped=true"
import script from "./ExternalMonitoring.vue?vue&type=script&lang=js"
export * from "./ExternalMonitoring.vue?vue&type=script&lang=js"
import style0 from "./ExternalMonitoring.vue?vue&type=style&index=0&id=18df68fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18df68fa",
  null
  
)

export default component.exports